import { render, staticRenderFns } from "./MortgageForm.vue?vue&type=template&id=65b3df30&"
import script from "./MortgageForm.vue?vue&type=script&lang=js&"
export * from "./MortgageForm.vue?vue&type=script&lang=js&"
import style0 from "./MortgageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports